
const rooms = [
    {
        id: 1,
        name: "Classroom",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/classroom.png",
    },
    {
        id: 2,
        name: "Cafeteria",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/cafeteria.jpg"
    },
    {
        id: 3,
        name: "Auditorium",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/auditorium.jpg",
    },
    {
        id: 4,
        name: "Principal's Office",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/principal_office.png",
    },
    {
        id: 5,
        name: "Locker Room",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/locker_room.png",
    },
    {
        id: 6,
        name: "Library",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/library.jpg",
    },
    {
        id: 7,
        name: "Science Lab",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/lab.png",
    },
    {
        id: 8,
        name: "Gymnasium",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/gym.png"
    },
    {
        id: 9,
        name: "Boiler Room",
        imageResource: "https://terror-prom-media.s3.amazonaws.com/room-images/boiler.jpg"
    },
]

export default rooms;